'use strict';

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var injectSheet = require('react-jss');
var classNames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = {
  button: {
    textAlign: 'left',
    background: 'none',
    color: 'inherit',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit'
  }
};

var _excluded = ["nodeRef", "classes", "className", "type"];

var ButtonElement = function ButtonElement(_ref) {
  var nodeRef = _ref.nodeRef,
      classes = _ref.classes,
      className = _ref.className,
      type = _ref.type,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement("button", _extends__default["default"]({
    ref: nodeRef,
    type: type || 'button',
    className: classNames__default["default"](classes.button, className)
  }, props));
};

var index = injectSheet__default["default"](styles)(ButtonElement);

module.exports = index;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src2416834937/src/pobble-app/client/~/pobble-components/dist/button-element/index.js